import { Button, ButtonProps } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

interface ComoButtonProps extends ButtonProps {
  secondary?: boolean;
}

export function ComoButton({ secondary = false, ...props }: ComoButtonProps) {
  const { colors: workspace } = useWorkspaceColors();

  const primaryStyle = {
    backgroundColor: workspace.accent,
    color: workspace.primary_dark,
    padding: { xs: "2px 10px", sm: "3px 16px" },
    border: `1px solid ${workspace.accent}`,
    "&:hover": {
      border: `1px solid ${workspace.accent}`,
      backgroundColor: alpha(workspace.accent, 0.8),
    },
  };

  const secondaryStyle = {
    backgroundColor: workspace.primary_dark,
    color: "white",
    padding: { xs: "2px 10px", sm: "3px 16px" },
    border: `1px solid ${workspace.primary_dark}`,
    "&:hover": {
      border: `1px solid ${workspace.primary_dark}`,
      backgroundColor: alpha(workspace.primary_dark, 0.8),
    },
  };

  return (
    <Button
      {...props}
      sx={{
        fontFamily: "Montserrat, sans-serif",
        fontWeight: "medium",
        textTransform: "none",
        ...(secondary ? secondaryStyle : primaryStyle),
        ...props.sx,
      }}
    />
  );
}
